import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faTriangleExclamation, faVideo, faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";
import PresetPickerInline from "./PresetPickerInline";
import { formatRepsPerSet, formatRestPerSet, parseRepsPerSet, parseRestPerSet } from "./workoutAdminHelpers";

export default function AssignmentItemModal({
  assignmentItemDraft,
  setAssignmentItemDraft,
  assignmentItemModalRef,
  closeAssignmentItemEditor,
  applyPreset,
  confirmDeletePreset,
  handleCreatePreset,
  handleRemoveStudentDemo,
  handleSaveAssignmentItem,
  handleSaveStudentDemoUrl,
  handleUploadStudentDemo,
  newPresetForm,
  setNewPresetForm,
  presets,
  presetsLoading,
  saving,
  savingPreset,
  setShowCreatePresetForm,
  showCreatePresetForm,
  uploadingDemo,
}) {
  return (
    <div className={styles.innerOverlay} onClick={closeAssignmentItemEditor}>
                      <div
                        className={styles.planModal}
                        ref={assignmentItemModalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="wam-assign-item-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className={styles.planModalHeader}>
                          <div>
                            <h3 id="wam-assign-item-title">Personalizar para o aluno</h3>
                            <p>{assignmentItemDraft.exercise_item_name}</p>
                          </div>

                          <button
                            type="button"
                            className={styles.planModalClose}
                            onClick={closeAssignmentItemEditor}
                            aria-label="Fechar modal"
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>

                        <form className={styles.wamForm} onSubmit={handleSaveAssignmentItem}>
                          <PresetPickerInline
                            presets={presets}
                            loading={presetsLoading}
                            onApply={(preset) => applyPreset(preset, "assignment")}
                            onDelete={confirmDeletePreset}
                            showCreateForm={showCreatePresetForm}
                            onToggleCreateForm={() => setShowCreatePresetForm((v) => !v)}
                            newPresetForm={newPresetForm}
                            onChangeNewPresetForm={setNewPresetForm}
                            onSubmitCreate={handleCreatePreset}
                            saving={savingPreset}
                          />

                          <div className={styles.setsRepsRow}>
                            <div className={styles.wamField} style={{width: 80, flexShrink: 0}}>
                              <label>Séries</label>
                              <input type="number" min={1} max={20} value={assignmentItemDraft.sets_planned}
                                onChange={(e) => { const n=Number(e.target.value)||0; setAssignmentItemDraft((prev)=>({...prev,sets_planned:e.target.value,reps_per_set:parseRepsPerSet(prev.reps_planned,n),rest_per_set:parseRestPerSet(prev.rest_seconds,n)})); }} />
                            </div>
                            {assignmentItemDraft.sets_planned > 0 && (() => {
                              const _isTimed = assignmentItemDraft.movement_type === 'core';
                              return (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>
                                  {_isTimed ? "⏱ Tempo por série" : "Repetições por série"}
                                </label>
                                {_isTimed && <span className={styles.timedHint}>Insira em segundos - ex: 30s, 45s, 60s</span>}
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(assignmentItemDraft.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="text" className={styles.repsPerSetInput}
                                        value={assignmentItemDraft.reps_per_set?.[i] ?? ""} placeholder={_isTimed ? "45s" : "-"}
                                        onChange={(e) => { const arr=[...(assignmentItemDraft.reps_per_set||[])]; arr[i]=e.target.value; setAssignmentItemDraft((prev)=>({...prev,reps_per_set:arr,reps_planned:formatRepsPerSet(arr)})); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                              );
                            })()}
                            {assignmentItemDraft.sets_planned > 0 && (
                              <div className={styles.repsPerSetSection}>
                                <label className={styles.repsPerSetSectionLabel}>Descanso por série (s)</label>
                                <div className={styles.repsPerSetRow}>
                                  {Array.from({ length: Number(assignmentItemDraft.sets_planned) }).map((_, i) => (
                                    <div key={i} className={styles.repsPerSetItem}>
                                      <span className={styles.repsPerSetLabel}>S{i+1}</span>
                                      <input type="number" className={styles.repsPerSetInput}
                                        value={assignmentItemDraft.rest_per_set?.[i] ?? ""} placeholder="-"
                                        onChange={(e) => { const arr=[...(assignmentItemDraft.rest_per_set||[])]; arr[i]=e.target.value; setAssignmentItemDraft((prev)=>({...prev,rest_per_set:arr,rest_seconds:formatRestPerSet(arr)})); }} />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                          <div className={styles.wamFormGrid3}>
                            <div className={styles.wamField}>
                              <label>Peso</label>
                              <input type="number" step="0.1" value={assignmentItemDraft.weight_planned}
                                onChange={(e) => setAssignmentItemDraft((prev) => ({ ...prev, weight_planned: e.target.value }))} />
                            </div>
                          </div>

                          <div className={styles.wamFormGrid}>
                            <div className={styles.wamField}>
                              <label>Duração</label>
                              <input
                                type="number"
                                value={assignmentItemDraft.duration_planned}
                                onChange={(e) =>
                                  setAssignmentItemDraft((prev) => ({ ...prev, duration_planned: e.target.value }))
                                }
                              />
                            </div>

                            <div className={styles.wamField}>
                              <label>Descanso (s)</label>
                              <input
                                type="number"
                                value={assignmentItemDraft.sets_planned > 0 ? "" : assignmentItemDraft.rest_seconds}
                                placeholder={assignmentItemDraft.sets_planned > 0 ? "Ver por série ↑" : ""}
                                disabled={assignmentItemDraft.sets_planned > 0}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  const n = Number(assignmentItemDraft.sets_planned) || 0;
                                  setAssignmentItemDraft((prev) => ({
                                    ...prev,
                                    rest_seconds: v,
                                    rest_per_set: n > 0 ? parseRestPerSet(v, n) : [],
                                  }));
                                }}
                              />
                            </div>
                          </div>

                          <div className={styles.wamField}>
                            <label>Observações</label>
                            <textarea
                              rows="3"
                              value={assignmentItemDraft.notes}
                              onChange={(e) =>
                                setAssignmentItemDraft((prev) => ({ ...prev, notes: e.target.value }))
                              }
                            />
                          </div>

                          <div className={styles.wamField}>
                            <label>
                              <FontAwesomeIcon icon={faVideo} style={{ marginRight: 6 }} />
                              Vídeo de demonstração personalizado (opcional)
                            </label>
                            <p className={styles.wamFieldHint}>
                              Só pra este aluno neste exercício - útil pra restrições/adaptações.
                              Vale em todos os treinos dele, mesmo depois de renovar. Sem nada
                              preenchido, continua usando a demonstração padrão da plataforma.
                            </p>

                            {!assignmentItemDraft.has_custom_demo && assignmentItemDraft.demo_url && (
                              <p className={styles.wamFieldHint}>
                                Sem vídeo personalizado ainda - hoje mostra a demonstração padrão da plataforma.
                                Cole um link ou envie um arquivo abaixo pra substituir só pra este aluno.
                              </p>
                            )}

                            {assignmentItemDraft.demo_source === "professor" && (
                              <p className={styles.wamFieldHint}>
                                Hoje mostra o vídeo próprio que você definiu em "Meus vídeos" pra este
                                exercício - vale pra todos os seus alunos sem vídeo específico. Cole um
                                link ou envie um arquivo abaixo pra definir um vídeo só pra este aluno
                                (substitui o do professor, sem afetar os demais).
                              </p>
                            )}

                            <label className={styles.wamFieldSubLabel}>URL da demonstração (YouTube/Shorts, GIF/MP4/WEBM ou imagem)</label>
                            <div className={styles.wamFieldRow}>
                              <input
                                type="text"
                                placeholder="Ex.: https://youtube.com/shorts/ID ou https://..."
                                value={assignmentItemDraft.demo_url_input || ""}
                                onChange={(e) => setAssignmentItemDraft((prev) => ({ ...prev, demo_url_input: e.target.value }))}
                                disabled={uploadingDemo}
                                style={{ flex: 1, minWidth: 0 }}
                              />
                              <button
                                type="button"
                                className={`${styles.wamBtn} ${styles.smallGhost}`}
                                onClick={handleSaveStudentDemoUrl}
                                disabled={uploadingDemo || !String(assignmentItemDraft.demo_url_input || "").trim()}
                              >
                                Salvar link
                              </button>
                            </div>

                            <label className={styles.wamFieldSubLabel}>Ou envie um arquivo (vídeo/gif/imagem) - a ação mais recente vale (salvar link substitui o arquivo salvo antes, e vice-versa)</label>
                            <input
                              type="file"
                              accept="video/mp4,video/webm,video/quicktime,.mov,.gif,.png,.jpg,.jpeg,.webp"
                              disabled={uploadingDemo}
                              onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) handleUploadStudentDemo(file);
                                e.target.value = "";
                              }}
                            />
                            {assignmentItemDraft.has_custom_demo && assignmentItemDraft.demo_source === "student" && (
                              <div className={styles.wamFieldRow}>
                                <span className={styles.customDemoBadge}>
                                  <FontAwesomeIcon icon={faVideo} /> Vídeo personalizado deste aluno ativo
                                </span>
                                <button
                                  type="button"
                                  className={`${styles.wamBtn} ${styles.smallDanger}`}
                                  onClick={handleRemoveStudentDemo}
                                  disabled={uploadingDemo}
                                >
                                  <FontAwesomeIcon icon={faTrashCan} /> Remover
                                </button>
                              </div>
                            )}
                            {assignmentItemDraft.has_custom_demo && assignmentItemDraft.demo_source === "professor" && (
                              <div className={styles.wamFieldRow}>
                                <span className={styles.customDemoBadge}>
                                  <FontAwesomeIcon icon={faVideo} /> Usando o vídeo do professor (não há vídeo próprio deste aluno)
                                </span>
                              </div>
                            )}
                            {assignmentItemDraft.demo_status === "failed" && (
                              // Vídeo continua tocável (fallback pro arquivo bruto, ver
                              // ExerciseDemoModal.jsx) — aviso não-bloqueante, por isso o
                              // mesmo padrão visual âmbar já usado noutros avisos do modal
                              // (ex.: confirmação de substituir treinos existentes).
                              <div style={{
                                background: "rgba(251,191,36,0.08)",
                                border: "1px solid rgba(251,191,36,0.22)",
                                borderRadius: 8,
                                padding: "10px 13px",
                                display: "flex",
                                gap: 8,
                                alignItems: "flex-start",
                                marginTop: 8,
                              }}>
                                <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "var(--feedback-warning)", fontSize: 13, marginTop: 2, flexShrink: 0 }} />
                                <p style={{ color: "var(--text-0-70)", fontSize: 12, margin: 0, lineHeight: 1.55 }}>
                                  O vídeo enviado não pôde ser otimizado automaticamente - continua funcionando normalmente, mas considere reenviar um arquivo menor ou mais curto.
                                </p>
                              </div>
                            )}
                            {uploadingDemo && <small>Enviando…</small>}
                          </div>

                          <div className={styles.actionsRow}>
                            <button
                              type="button"
                              className={`${styles.wamBtn} ${styles.ghost}`}
                              onClick={closeAssignmentItemEditor}
                            >
                              Cancelar
                            </button>
                            <button
                              type="submit"
                              className={`${styles.wamBtn} ${styles.primary}`}
                              disabled={saving}
                            >
                              Salvar ajuste
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
  );
}
